export default __webpack_public_path__ + "static/media/torso-low-back.8ef575f2.png";